<ag-grid-angular #agGrid class="ag-theme-alpine-dark ag-theme-ix" [rowData]="data" [columnDefs]="orgsColumnDefs"
  [getRowStyle]="getRowStyle"  [gridOptions]="gridOptions" suppressCellFocus >
</ag-grid-angular>
<ix-button (click)="onRefreshData()" class="refresh-button">Refresh Data</ix-button>